import React, { Component } from 'react'
import PitchEntity from '../../components/Pitch/PitchEntity'
import PlayerMoveToWithSpeed  from '../Animations/Movements/PlayerMoveToWithSpeed'
import PlayerMoveTo  from '../Animations/Movements/PlayerMoveTo'
import BrownianMovement from '../Animations/Movements/BrownianMovement'
import { getInterval } from './gameJson'
import {calculateColor} from '../Animations/helper'

class Player extends PitchEntity {

  static propTypes = {
      player: React.PropTypes.object.isRequired,
      home: React.PropTypes.bool.isRequired,
      index: React.PropTypes.number.isRequired,
      onSelect: React.PropTypes.func.isRequired,
      convertToPitchPosition: React.PropTypes.func.isRequired,
      reflectPosition: React.PropTypes.func.isRequired,
      getKeyPoints: React.PropTypes.func.isRequired,
      getPositionOnBench: React.PropTypes.func.isRequired,
      currentEvent: React.PropTypes.number.isRequired,
      gameSpeed: React.PropTypes.number.isRequired,
      shirtBackground: React.PropTypes.string.isRequired,
      shirtTextColor: React.PropTypes.string.isRequired,
      shirtBorderColor: React.PropTypes.string.isRequired,
      size: React.PropTypes.number.isRequired,
  }

    constructor(props) {
        super(props);
        this.CurrentPosition = this.props.getKeyPoints(this.props.home).startPoint;
        //this.CurrentPosition = {Top:0, Left: 0};

        if(this.props.player.BenchSlot != null)
          this.CurrentPosition = this.props.getPositionOnBench(this);

        this._hasYellowCard = false;
        this._hasRedCard = false;
        this.Settings = window.PitchSettings;

        this._cacheIndex = null;
        this.ImAnOwner = false;
        this.zIndex = 1;
    }

    get Id() {
      return this.props.player.Id;
    }

    set HasYellowCard(val) {
      this._hasYellowCard = val;
    }

    get HasYellowCard() {
      return this._hasYellowCard == true || this.props.player.Stats.HasYellowCard == true;
    }

    set HasRedCard(val) {
      this._hasRedCard = val;
    }

    get HasRedCard() {
      return this._hasRedCard || this.props.player.Stats.HasRedCard == true;
    }

    get OnBench() {
      return this.props.player.BenchSlot != null;
    }

    _dropFlags() {
      this.wasSubOut = false;
    }

    convertToHomeAwayPosition(isForHome){
      if(isForHome == this.props.home)
        return this.CurrentPosition;
      else
        return this.props.reflectPosition(this.CurrentPosition)
    }

    readPosByNum(eventNum, num, isHome) {
      var currentEventCoordsSet = window.Json.game[eventNum-1].coordinates;
      if(currentEventCoordsSet == null)
        return null;
      else {
        var homeOrAway = isHome ? currentEventCoordsSet.home : currentEventCoordsSet.away;
        for (var i = 0; i < homeOrAway.length; i++) {
          var element = homeOrAway[i];
          if(element.n == num)
            return {
              Top: element.h,
              Left: element.w,
            }
        }

        return null;
      }
    }

    readEvent(eventNum, takeInPastIfNotExisits = false){
      var isHome = this.props.home;
      var num = this.props.num;
      //this._dropFlags();

      if(eventNum == 0)
        return { position: this.CurrentPosition, time: 1000}; 

      var currentEventCoordsSet = window.Json.game[eventNum-1].coordinates;
      var time = getInterval(eventNum-1);

      if(currentEventCoordsSet != null) {
        var homeOrAway = isHome ? currentEventCoordsSet.home : currentEventCoordsSet.away;
        var position = this.getPositionByNum(homeOrAway, num);
        var owner = this.getOwner(window.Json.game[eventNum]);
        return { position, time, owner };
      }
      else {
        if(takeInPastIfNotExisits == false)
          return { position: this.CurrentPosition, time: time};
        else {
          let event = eventNum;
          while(event >= 0) {
            if(window.Json.game[event].coordinates != null){
              return this.readEvent(event+1);
            }
              
            event--;
          }
        }
      }
    }

    getOwner(event) {
      if(event != null && event.messages != null && event.messages.length >0) {
        return event.messages[0].owner;
      }

      return null;
    }

    getPositionByNum(array, num) {
      if(this._cacheIndex != null) {
        let el = array[this._cacheIndex];
        if(el != null && el.n == num)
          return {
            Top: el.h,
            Left: el.w,
          };
      }
      
      for (var i = 0; i < array.length; i++) {
        var element = array[i];
        if(element.n == num) {
          this._cacheIndex = i;
          return {
            Top: element.h,
            Left: element.w,
          }
        }
      }

      return this.props.getPositionOnBench(this)
    }

    getNextPosition() {
      let currentEvent = this.props.currentEvent;
      let next_position = null;
      while(next_position == null && currentEvent < window.Json.game.length) {
        if(window.Json.game[currentEvent-1].coordinates != null) {
          let a = this.readEvent(currentEvent);
          return a.position;
        }
        currentEvent++;
      }

      return this.CurrentPosition;
    }

    playMovementAnimation(new_position, time, owner, hideModel) {
      if(owner != null) {
        this.ImAnOwner = this.props.home && owner == 1 || !this.props.home && owner == 2;
      }
      
      if(this.CurrentPosition.Top != new_position.Top || this.CurrentPosition.Left != new_position.Left) {
        this.CurrentAnimation = new PlayerMoveTo(this, time, new_position, this.ImAnOwner, hideModel);
        this.CurrentAnimation.Play(this.props.gameSpeed).catch(this.processCancellation)
      }
      else {
        if(!this.OnBench)
        {
          this.CurrentAnimation = new BrownianMovement(this, time);
          this.CurrentAnimation.Play(this.props.gameSpeed).catch(this.processCancellation)
        }
      }
    }

    WalkToNextPosition(gameSpeed, playerSpeed, useBrownian = true) {
        let {position} = this.readEvent(this.props.currentEvent+1);
        if(position != null)
          return this.MoveToWithSpeed(gameSpeed, playerSpeed, position, {useBrownian: useBrownian}).catch(this.processCancellation);
    }

    getColors() {
      if(!this.Settings.DefaultColors || this.props.index == 0) {
        //if(this.props.index != 0)
        //return {};
        
        return {
          background: this.props.shirtBackground,
          color: this.props.shirtTextColor,
          borderColor: this.props.shirtBorderColor
        }
      }
      else {
        if(this.props.home)
          return {
            background: 'pink',
            color: 'black',
            borderColor: 'pink'
          }
        else
          return {
            background: 'DodgerBlue',
            color: 'white',
            borderColor: 'DodgerBlue'
          }
      }
    }

    render() {
        let player = this.props.player;

        if(player.Stats.HasRedCard == true || this.CheckIfOutsidePitch() || this.InjuredWithoutSubstitution())
          return null;

        let id = "player_" + player.Id;
        let isSelected = player.Selected || player.HighLighted && this.Settings.PlayerNames == 0 || ((this.Settings.PlayerNames == 1 || this.Settings.PlayerNames == 2 && this.props.home || this.Settings.PlayerNames == 3 && !this.props.home) && !this.OnBench);
        
        let position = this.props.convertToPitchPosition(this.CurrentPosition, this.props.home);

        var diff = this.getPositionDiff();
        var top = position.Top - diff;
        var left = position.Left - diff;

        const divStyle = {
          top: top + 'px',
          left: left + 'px',
          zIndex: this.zIndex,
          opacity: this.opacity
        };

        const playerShapeStyle = this.getColors();

        let showCoordinates = false;
        var title="";
        if(showCoordinates){
          title = `${this.CurrentPosition.Left.toFixed(0)},${this.CurrentPosition.Top.toFixed(0)}`;
        }

        return (<div id={id} title={title} style={divStyle} className={this.getContainerClass()}>
                  <div onClick={event => this.props.onSelect(player.Id, !player.Selected)} style={playerShapeStyle} className={this.props.home ? "player_shape home" : "player_shape away"} >
                    <div className="player_number">{player.Number}</div>
                  </div>
                  {isSelected === true &&
                    <span className={this.getNameTextClass()}>{player.Name.LastName}</span>
                  }
                  {isSelected === true && this.Settings.ShowPlayerFatigue &&
                    <div className="player_fatigue">
                      <div className="fatigue_level" style={{background: calculateColor(player.Stats.Fatigue), width: this.calculateFatigueWidth(player.Stats.Fatigue)}}></div>
                    </div>
                  }
                </div>)
    }

    getNameTextClass() {
      if(this.HasRedCard)
        return "player_name red";
      
      if(this.HasYellowCard)
        return "player_name yellow";

      return "player_name"
    }

    calculateFatigueWidth(fatigue) {
      let val = (6 - fatigue) * 100 / 6;
      if(fatigue > 2)
        val = val + 10;
      return val + '%'
    }
}

export default Player



/** WEBPACK FOOTER **
 ** ./src/components/Pitch/Player.js
 **/